import { useEffect } from "react"
import { useParams, useNavigate, Outlet } from "react-router-dom"

const LanguageRoute = ({ settings, setSettings }) => {
    const { lang } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        // Map URL language codes to our internal language codes
        const languageMap = {
            'de': 'de-DE',
            'it': 'it-IT',
            'en': 'en-US'
        }

        // If no language is specified, determine the preferred language
        if (!lang) {
            const userLanguage = navigator.language || navigator.userLanguage
            let preferredLang = 'en' // default to English

            if (userLanguage) {
                switch (userLanguage.toLowerCase()) {
                    case 'it':
                    case 'it-it':
                        preferredLang = 'it'
                        break
                    case 'de':
                    case 'de-at':
                    case 'de-de':
                    case 'de-ch':
                        preferredLang = 'de'
                        break
                    case 'en':
                    case 'en-us':
                    case 'en-gb':
                        preferredLang = 'en'
                        break
                    default:
                        preferredLang = 'en'
                        break
                }
            }

            navigate(`/${preferredLang}`, { replace: true })
            return
        }

        // If an invalid language is specified, redirect to the default language
        if (!languageMap[lang]) {
            navigate('/de', { replace: true })
            return
        }

        // Update the language setting if it's different from the current one
        if (settings.language !== languageMap[lang]) {
            setSettings({
                ...settings,
                language: languageMap[lang]
            })
        }
    }, [lang, settings, setSettings, navigate])

    return <Outlet />
}

export default LanguageRoute 